import { authActionTypes } from "../constants/authActionTypes";
import { uploadsActionTypes } from "../constants/uploadsActionTypes";

const initialState = {
    uploads:null
}
export const uploadsReducer = (state = initialState, action) => {
    switch (action.type) {
        case uploadsActionTypes.SET_UPLOADS:return {...state,uploads:action.payload}
        case authActionTypes.LOGOUT: return initialState
        default: return state;
    }
}